module.exports = __webpack_public_path__ + "8f04ed9aeb2185499068d84842b95aa1.svg";